module.exports = __webpack_public_path__ + "img/battery_2green.742b497f.png";